import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "row",
  style: {"text-align":"center"}
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  class: "col",
  style: {"text-align":"right"}
}
const _hoisted_10 = {
  class: "col",
  style: {"text-align":"left"}
}
const _hoisted_11 = {
  class: "col",
  style: {"text-align":"right"}
}
const _hoisted_12 = {
  class: "col",
  style: {"text-align":"left"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-10 offset-md-1" }, " Reverse hanging is only used for directional required products, such as louvers and pattern glass. Pattern glass with face the outside. Louver slats face down toward stop on standard hanging and up toward door stop on reverse hand doors. ")
], -1)

import { computed } from 'vue'
  import { useAppStore } from '@/stores/app'
  import SimpleModal from '@/components/modals/SimpleModal.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SwingInfoModal',
  props: {
      modelValue: { type: Boolean, required: true, default: false },
      isSingleSwingInfo: { type: Boolean, required: true },
      isFireOrExterior: { type: Boolean, required: false, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props

  

  

  const value = computed({
    get() {
      return props.modelValue
    },
    set(value) {
      emit('update:modelValue', value)
    }
  })

  const appStore = useAppStore()


return (_ctx: any,_cache: any) => {
  return (_unref(value))
    ? (_openBlock(), _createBlock(SimpleModal, {
        key: 0,
        onHidden: _cache[0] || (_cache[0] = () => {value.value = false}),
        title: __props.isSingleSwingInfo ? 'Single Door Swing' : 'Double Door Swing',
        "show-footer": false,
        "modal-size": "lg"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (__props.isSingleSwingInfo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(appStore).publicPath + '/single.png',
                    alt: "Single Door Swings"
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _unref(appStore).publicPath + '/double.png',
                    alt: "Double Door Swings"
                  }, null, 8, _hoisted_4))
            ]),
            _createElementVNode("div", _hoisted_5, [
              (__props.isSingleSwingInfo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(appStore).publicPath + '/single-reverse.png',
                    alt: "Single Door Reverse Swings"
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _unref(appStore).publicPath + '/double-reverse.png',
                    alt: "Double Door Reverse Swings"
                  }, null, 8, _hoisted_7))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, " Left Hand" + _toDisplayString(__props.isSingleSwingInfo ? "" : " Active") + _toDisplayString(__props.isFireOrExterior ? " Inswing" : ""), 1),
            _createElementVNode("div", _hoisted_10, " Right Hand" + _toDisplayString(__props.isSingleSwingInfo ? "" : " Active") + _toDisplayString(__props.isFireOrExterior ? " Inswing" : ""), 1),
            _createElementVNode("div", _hoisted_11, " Right Hand" + _toDisplayString(__props.isSingleSwingInfo ? "" : " Active") + _toDisplayString(__props.isFireOrExterior ? " Outswing" : " Reverse"), 1),
            _createElementVNode("div", _hoisted_12, " Left Hand" + _toDisplayString(__props.isSingleSwingInfo ? "" : " Active") + _toDisplayString(__props.isFireOrExterior ? " Outswing" : " Reverse"), 1)
          ]),
          _hoisted_13
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}
}

})